import { IPrestacaoContasPagedResponse } from "models/response/prestacao-contas-paged-response";

export interface PrestacaoContasDetailsState {
  prestacaoContasDetails: IPrestacaoContasPagedResponse | null;
  loading: boolean;
  error: string | null;
}

export const ACTION_TYPES = {
  setPrestacaoContasDetails: 'setPrestacaoContasDetails',
  setLoading: 'setLoading',
  setError: 'setError',
} as const;

type ActionType = keyof typeof ACTION_TYPES;

export interface PrestacaoContasDetailsAction {
  type: ActionType;
  payload: any;
}

export const PrestacaoContasDetailsReducer = (
  state: PrestacaoContasDetailsState,
  action: PrestacaoContasDetailsAction
): PrestacaoContasDetailsState => {
  switch (action.type) {
    case ACTION_TYPES.setPrestacaoContasDetails:
      return { ...state, prestacaoContasDetails: action.payload, error: null };
    case ACTION_TYPES.setLoading:
      return { ...state, loading: action.payload };
    case ACTION_TYPES.setError:
      return { ...state, error: action.payload, loading: false };
    default:
      return state;
  }
};
